import { useEffect, useRef, useState } from 'react';

const PREVIEW_SOURCE = 'caav-preview';

const sitios = require('../location.json').sitio;
const URL_SITIO = window.location.origin.includes('localhost') ? sitios.local : sitios.production;
const ORIGEN_SITIO = new URL(URL_SITIO).origin;

const usePreviewSitio = ({ page, ruta, data, onSelect }) => {
    const iframeRef = useRef(null);
    // Se incrementa en cada preview:ready para reenviar el borrador si el iframe se recarga
    const [listo, setListo] = useState(0);
    const onSelectRef = useRef(onSelect);
    onSelectRef.current = onSelect;

    useEffect(() => {
        const recibir = evento => {
            if (evento.origin !== ORIGEN_SITIO) return;
            if (evento.source !== iframeRef.current?.contentWindow) return;
            const mensaje = evento.data;
            if (mensaje?.source !== PREVIEW_SOURCE || mensaje.page !== page) return;

            if (mensaje.type === 'preview:ready') setListo(n => n + 1);
            if (mensaje.type === 'preview:select') onSelectRef.current?.(mensaje);
        };

        window.addEventListener('message', recibir);
        return () => window.removeEventListener('message', recibir);
    }, [page]);

    useEffect(() => {
        if (!listo) return;
        iframeRef.current?.contentWindow?.postMessage(
            { source: PREVIEW_SOURCE, type: 'preview:data', page, data },
            ORIGEN_SITIO
        );
    }, [listo, page, data]);

    // ruta puede traer su propio query (ej. '/?seccion=enterate')
    const url = new URL(ruta, URL_SITIO);
    url.searchParams.set('preview', '1');

    return { iframeRef, src: url.toString() };
};

export default usePreviewSitio;
